import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class ShareIncoming extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Share Request');
    public static getDescription:Function = () => Locale.gettext('A user wishes to share access with you');
    
    public static supportedRoutes:string[] = [ "push", "email" ];
}